import { Menu } from "@/domain/main-header/entity/Menu.interface";
import { MenuTitle } from "@/domain/main-header/entity/MenuTitle.interface";
import { MainHeaderTitle } from "@/domain/main-header/entity/MainHeaderTitle.enum";
import { MenuTitleCategoryDTO, MenuTitleDTO, SubMenuDTO } from "@/domain/main-header/dto";
import { MenuTitleCategory } from "@/domain/main-header/entity/MenuTtitleCategory.interface";
import { MenuTitleSubCategory } from "@/domain/main-header/entity/MenuTitleSubCategory.interface";

export class MenuBuilder {
    private menu: Menu = {};

    public addEvents(data: MenuTitle | null): MenuBuilder {
        if (data) {
            this.menu[MainHeaderTitle.EVENTS] = data;
        }

        return this;
    }

    public addLocations(data: SubMenuDTO): MenuBuilder {
        if (data[MainHeaderTitle.LOCATIONS]) {
            this.menu[MainHeaderTitle.LOCATIONS] = this.normalizeMenuTitleData(
                data[MainHeaderTitle.LOCATIONS],
                MainHeaderTitle.LOCATIONS
            )
        }

        return this;
    }

    public addArtists(data: SubMenuDTO): MenuBuilder {
        if (data[MainHeaderTitle.ARTISTS]) {
            this.menu[MainHeaderTitle.ARTISTS] = this.normalizeMenuTitleData(
                data[MainHeaderTitle.ARTISTS],
                MainHeaderTitle.ARTISTS
            )
        }

        return this;
    }

    public addCustomTab(data: SubMenuDTO): MenuBuilder {
        if (data[MainHeaderTitle.CUSTOM_TAB]) {
            this.menu[MainHeaderTitle.CUSTOM_TAB] = this.normalizeMenuTitleData(
                data[MainHeaderTitle.CUSTOM_TAB],
                MainHeaderTitle.CUSTOM_TAB
            )
        }

        return this;
    }

    public build(): Menu {
        return this.menu;
    }

    private normalizeMenuTitleData(data: MenuTitleDTO, sectionName: MainHeaderTitle): MenuTitle {
        return {
            sectionName,
            name: data.name ?? '',
            title: data.title ?? '',
            url: data.url ?? undefined,
            showChildren: data.showChildren ?? false,
            sectionButton: data.seeAll ?? undefined,
            categories: this.normalizeCategoryData(data.children ?? []),
            promotions: data.promotions ?? [],
        }
    }

    private normalizeCategoryData(data: MenuTitleCategoryDTO[]): MenuTitleCategory[] {
        return data.map((category: MenuTitleCategoryDTO) => {
            return {
                id: category.id ?? '',
                name: category.name ?? '',
                title: category.title ?? '',
                url: category.url ?? '',
                label: category.label ?? '',
                auth: category.auth ?? false,
                showChildren: category.showChildren ?? false,
                subCategories: this.normalizeSubCategoryData(category.children ?? []),
            }
        });
    }

    private normalizeSubCategoryData(data: MenuTitleSubCategory[]): MenuTitleSubCategory[] {
        return data.map((subCategory: MenuTitleSubCategory) => {
            return {
                id: subCategory.id ?? '',
                name: subCategory.name ?? '',
                title: subCategory.title ?? '',
                url: subCategory.url ?? '',
            }
        });
    }

}
